/**
 * Simple Image Lightbox - Sin dependencias externas
 * Funciona en localhost y producción
 */

(function() {
  'use strict';

  let currentIndex = 0;
  let images = [];
  let lightboxElement = null;

  // Crear estructura del lightbox
  function createLightbox() {
    if (lightboxElement) return;

    const html = `
      <div class="simple-lightbox" id="simpleLightbox" style="display: none;">
        <div class="simple-lightbox__overlay"></div>
        <div class="simple-lightbox__content">
          <button class="simple-lightbox__close" aria-label="Cerrar">&times;</button>
          <button class="simple-lightbox__prev" aria-label="Anterior">&lsaquo;</button>
          <button class="simple-lightbox__next" aria-label="Siguiente">&rsaquo;</button>
          <div class="simple-lightbox__image-container">
            <img class="simple-lightbox__image" alt="" />
            <div class="simple-lightbox__loader"></div>
          </div>
          <div class="simple-lightbox__counter"></div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);
    lightboxElement = document.getElementById('simpleLightbox');

    // Event listeners
    lightboxElement.querySelector('.simple-lightbox__close').addEventListener('click', closeLightbox);
    lightboxElement.querySelector('.simple-lightbox__prev').addEventListener('click', showPrevImage);
    lightboxElement.querySelector('.simple-lightbox__next').addEventListener('click', showNextImage);
    lightboxElement.querySelector('.simple-lightbox__overlay').addEventListener('click', closeLightbox);

    // Teclado
    document.addEventListener('keydown', handleKeyboard);

    // Touch gestures para mobile
    setupTouchGestures();
  }

  // Configurar gestos táctiles
  function setupTouchGestures() {
    let touchStartX = 0;
    let touchEndX = 0;

    lightboxElement.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    lightboxElement.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    function handleSwipe() {
      const swipeThreshold = 50;
      if (touchEndX < touchStartX - swipeThreshold) {
        showNextImage(); // Swipe izquierda
      }
      if (touchEndX > touchStartX + swipeThreshold) {
        showPrevImage(); // Swipe derecha
      }
    }
  }

  // Manejo de teclado
  function handleKeyboard(e) {
    if (!lightboxElement || lightboxElement.style.display === 'none') return;

    switch(e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        showPrevImage();
        break;
      case 'ArrowRight':
        showNextImage();
        break;
    }
  }

  // Abrir lightbox
  function openLightbox(index) {
    createLightbox();
    currentIndex = index;
    
    lightboxElement.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    loadImage(currentIndex);
    updateCounter();
    updateNavigation();

    // Animación de entrada
    setTimeout(() => {
      lightboxElement.classList.add('active');
    }, 10);
  }

  // Cerrar lightbox
  function closeLightbox() {
    lightboxElement.classList.remove('active');
    
    setTimeout(() => {
      lightboxElement.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  // Cargar imagen
  function loadImage(index) {
    const img = lightboxElement.querySelector('.simple-lightbox__image');
    const loader = lightboxElement.querySelector('.simple-lightbox__loader');
    
    loader.style.display = 'block';
    img.style.opacity = '0';

    const newImg = new Image();
    newImg.onload = function() {
      img.src = this.src;
      img.alt = images[index].alt;
      img.style.opacity = '1';
      loader.style.display = 'none';
    };
    newImg.src = images[index].src;
  }

  // Navegación
  function showPrevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    loadImage(currentIndex);
    updateCounter();
    updateNavigation();
  }

  function showNextImage() {
    currentIndex = (currentIndex + 1) % images.length;
    loadImage(currentIndex);
    updateCounter();
    updateNavigation();
  }

  // Actualizar contador
  function updateCounter() {
    const counter = lightboxElement.querySelector('.simple-lightbox__counter');
    counter.textContent = `${currentIndex + 1} / ${images.length}`;
  }

  // Actualizar botones de navegación
  function updateNavigation() {
    const prevBtn = lightboxElement.querySelector('.simple-lightbox__prev');
    const nextBtn = lightboxElement.querySelector('.simple-lightbox__next');

    if (images.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'flex';
    }
  }

  // Inicializar para la galería de producto
  function initProductGallery() {
    const galleryContainer = document.querySelector('[data-product-gallery]');
    if (!galleryContainer) return;

    function setupGallery() {
      // Recopilar imágenes
      images = [];
      const slides = galleryContainer.querySelectorAll('.swiper-slide');
      
      slides.forEach((slide, index) => {
        const img = slide.querySelector('img.product-gallery-swiper__image');
        if (!img) return;

        // URL de alta resolución
        const highResSrc = img.src.replace(/width=\d+/, 'width=2000');
        
        images.push({
          src: highResSrc,
          alt: img.alt || 'Imagen del producto'
        });

        // Agregar click listener
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(index);
        });
      });

      console.log('Simple Lightbox initialized with', images.length, 'images');
    }

    // Esperar a que Swiper esté listo
    if (galleryContainer.hasAttribute('data-initialized')) {
      setupGallery();
    } else {
      const observer = new MutationObserver(function() {
        if (galleryContainer.hasAttribute('data-initialized')) {
          setupGallery();
          observer.disconnect();
        }
      });

      observer.observe(galleryContainer, {
        attributes: true,
        attributeFilter: ['data-initialized']
      });
    }
  }

  // Iniciar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
})();
